import React from "react"
import autobind from "class-autobind"
import FormTextField from "./form-components/FormTextField"
import FormDateField from "./form-components/FormDateField"
import FormDateChipSetField from "./form-components/FormDateChipSetField"
import FormTextChipSetField from "./form-components/FormTextChipSetField"


interface IProps {
    field
    onChange(key, value): void
    value
}

interface IState {
}

export default class FormField extends React.Component<IProps, IState> {
  constructor(props: IProps) {
      super(props);
      autobind(this);
  }

  render() {
      const { field, value, onChange } = this.props;
      return (
        <span>
          {(field.component === "text-field" || field.component === "multi-line-text-field" || field.component === "ai-prompt") &&
            <FormTextField 
              value={value} 
              field={field}
              onChange={onChange}              
            />
          }

          {field.component === "date-field" && 
            <FormDateField 
              value={value} 
              field={field}
              onChange={onChange}              
            />
          }

          {field.component === "date-field-chip-set" && 
            <FormDateChipSetField 
              value={Array.isArray(value) ? value : []} // Ensure value is an array
              field={field}
              onChange={onChange}  // This will handle date changes             
            />
          }

          {field.component === "text-field-chip-set" && 
            <FormTextChipSetField 
              value={Array.isArray(value) ? value : []} // Ensure value is an array
              field={field}
              onChange={onChange}  // This will handle date changes             
            />
          }             
        </span>
      );
  }
}